export const isInsideEditingArea = (target: EventTarget | null, selectors: readonly string[]): boolean => {
	if (target == null) {
		return false;
	}

	let element: Element;

	if (target instanceof Element) {
		element = target;
	} else if (target instanceof Node && target.parentElement != null) {
		element = target.parentElement;
	} else {
		return false;
	}

	return selectors.some(selector => element.closest(selector) != null);
};
